import createIcon from '../../createIcon';

/**
 * @component @name Addchart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNSA1LjVWNy41SDE4LjVWMTAuNUgxNi41VjcuNUgxMy41VjUuNUgxNi41VjIuNUgxOC41VjUuNUgyMS41Wk0xOC41IDE5LjVINC41VjUuNUgxMC41VjMuNUg0LjVDMy40IDMuNSAyLjUgNC40IDIuNSA1LjVWMTkuNUMyLjUgMjAuNiAzLjQgMjEuNSA0LjUgMjEuNUgxOC41QzE5LjYgMjEuNSAyMC41IDIwLjYgMjAuNSAxOS41VjEzLjVIMTguNVYxOS41Wk0xNC41IDEzLjVWMTcuNUgxNi41VjEzLjVIMTQuNVpNMTAuNSAxNy41SDEyLjVWOS41SDEwLjVWMTcuNVpNOC41IDE3LjVWMTEuNUg2LjVWMTcuNUg4LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Addchart = createIcon('Addchart', [
  [
    'path',
    {
      d: 'M21.5 5.5V7.5H18.5V10.5H16.5V7.5H13.5V5.5H16.5V2.5H18.5V5.5H21.5ZM18.5 19.5H4.5V5.5H10.5V3.5H4.5C3.4 3.5 2.5 4.4 2.5 5.5V19.5C2.5 20.6 3.4 21.5 4.5 21.5H18.5C19.6 21.5 20.5 20.6 20.5 19.5V13.5H18.5V19.5ZM14.5 13.5V17.5H16.5V13.5H14.5ZM10.5 17.5H12.5V9.5H10.5V17.5ZM8.5 17.5V11.5H6.5V17.5H8.5Z',
      key: '1pagwd',
    },
  ],
]);

export default Addchart;
